function cleanJobDescription(html) {
  const container = document.createElement('div');
  container.innerHTML = html;

  // Remove tags that are visually empty (whitespace + <br> is considered empty)
  Array.from(container.querySelectorAll('*')).forEach((el) => {
    const raw = el.innerHTML.replace(/<br\s*\/?>/gi, '').replace(/&nbsp;|\s/g, '');
    const text = el.textContent.trim();

    if (!text && !raw) {
      el.remove();
    }
  });

  return container.innerHTML.trim();
}

export {
  cleanJobDescription,
};